import React from "react";
import returnsDT from "../../data/content/returns";
import DecisionTree from "../../components/decision-tree/DecisionTree";
import analyticsTrigger from "../../utils/analytics/trigger/analyticsTrigger";
import buildPathName from "../../utils/buildPathName";
import { isFeatureEnabled } from "@/utils/feature-flags";
import FeatureFlagProvider from "@/context/FeatureFlagContext";
import { extractExperiences, useExperience } from "@/context/MonetateContext";

const analyticsNameEventMap = {
  notWantedLarge: "not wanted",
  faultyLarge: "faulty",
  otherFaulty: "other",
  returningRoyalMail: "royal mail",
  returningOthers: "other",
};

export const getServerSideProps = async ctx => {
  const isAgentForceGitlabFlagEnabled = await isFeatureEnabled(ctx, "agent_force_returns_page");
  const showMiawChat = await isFeatureEnabled(ctx, "show_miaw_chat");
  const uberEatsRedirect = await isFeatureEnabled(ctx, "uber_eats_redirect");
  const experiences = extractExperiences(ctx.req);

  return {
    props: {
      isAgentForceGitlabFlagEnabled,
      showMiawChat,
      uberEatsRedirect,
      experiences,
    },
  };
};

export const metadata = {
  title: `Returns & Refunds | Customer Services`,
  description: `Have a question? We're here to help with all your queries, from delivery and returns to orders and your online account and your My John Lewis membership.`,
};

function Returns({ isAgentForceGitlabFlagEnabled, showMiawChat, uberEatsRedirect }) {
  const agentForceMonetateExperience = useExperience(
    "RD | AB-5812 | Customer & Account | Returns & Refunds | Agentforce chat button visibility",
  );

  // Check if experiment is loaded (active means Monetate has returned a value)
  const isExperimentLoaded = !!agentForceMonetateExperience;
  // Check if variant is "Experiment"
  const isExperimentVariant = agentForceMonetateExperience?.variantLabel === "Experiment";

  // Always include AF chat options when the feature flag is enabled; visibility is controlled later
  const showAgentForceChatButton = isAgentForceGitlabFlagEnabled;
  const content = returnsDT({ showAgentForceChatButton });

  const analyticsHandler = elements => {
    if (elements) {
      analyticsTrigger(
        "dataStateChange",
        buildPathName(`${elements[0] === "trackReturnAndRefund" ? "" : ":returns"}`, analyticsNameEventMap, elements),
        {},
        "pageload",
      );
    }
  };

  console.log("[Returns] Experiment state:", {
    isExperimentLoaded,
    variantLabel: agentForceMonetateExperience?.variantLabel,
    isExperimentVariant,
    agentForceMonetateExperience,
  });

  return (
    <FeatureFlagProvider features={{ show_miaw_chat: showMiawChat }}>
      <DecisionTree
        content={content}
        startKey="returnsAndRefunds"
        defaultBackText="Returns and refunds"
        onTreeUpdate={analyticsHandler}
        uberEatsRedirect={uberEatsRedirect}
        isExperimentLoaded={isExperimentLoaded}
        isExperimentVariant={isExperimentVariant}
      />
    </FeatureFlagProvider>
  );
}

Returns.metadata = metadata;

export default Returns;
